import { useApi } from '@backstage/core-plugin-api';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { approvalApiRef, type ApprovalResponse } from '../api/approvalApi';

const useStyles = makeStyles(theme => ({
  page: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(6, 3),
  },
  panel: {
    width: '100%',
    maxWidth: 640,
    padding: theme.spacing(5),
    textAlign: 'center',
  },
  icon: {
    fontSize: 56,
    marginBottom: theme.spacing(2),
  },
  success: { color: theme.palette.success.main },
  error: { color: theme.palette.error.main },
  title: { marginBottom: theme.spacing(1) },
}));

export const ApproveAsRolePage = () => {
  const classes = useStyles();
  const api = useApi(approvalApiRef);
  const { taskId } = useParams<{ taskId: string }>();
  const [approval, setApproval] = useState<ApprovalResponse | undefined>();
  const [error, setError] = useState<Error>();

  useEffect(() => {
    if (!taskId) {
      setError(new Error('Missing task ID'));
      return;
    }

    api
      .approveAsRole(taskId)
      .then(() => api.getApproval(taskId))
      .then(result => {
        if (!result) {
          throw new Error('Approval not found');
        }

        setApproval(result);
      })
      .catch(setError);
  }, [api, taskId]);

  return (
    <Box className={classes.page}>
      <Paper className={classes.panel} elevation={2}>
        {!approval && !error && <CircularProgress />}
        {approval && (
          <>
            <CheckCircleIcon className={`${classes.icon} ${classes.success}`} />
            <Typography variant="h4" className={classes.title}>
              Approval recorded
            </Typography>
            <Typography color="textSecondary">
              Task {approval.taskId} has been approved with your available role.
            </Typography>
          </>
        )}
        {error && (
          <>
            <ErrorIcon className={`${classes.icon} ${classes.error}`} />
            <Typography variant="h4" className={classes.title}>
              Approval could not be recorded
            </Typography>
            <Typography color="textSecondary">{error.message}</Typography>
          </>
        )}
      </Paper>
    </Box>
  );
};
